export default __webpack_public_path__ + "static/media/icon-coin-crv.314a6445.svg";